export default __webpack_public_path__ + "static/1728-dbf1d9e8d39f3929dc1b345ba8b7afb9.gif";